import React from 'react';
import Seo from '@/components/Seo';
import { Products as ProductsSection } from '@/components/products';
import { productsContent } from '@/content/products';

/**
 * Standalone "Products" page, linked from the navbar's "Products" entry
 * (see `siteConfig.pages`). Reuses the home page's `Products` section
 * component as-is, so the products content/markup stays in sync wherever
 * it's rendered — it is not removed from the home page (see `Home.tsx`),
 * only additionally reachable via this dedicated page.
 */
const Products: React.FC = () => {
    return (
        <>
            <Seo title={productsContent.sectionTitle} path="/products" breadcrumbs={[]} />
            <ProductsSection />
        </>
    );
};

export default Products;
